import HomeSlider from "../features/homeSlider/HomeSlider"
import AllServicesBox from "../features/services/AllServicesBox"
import LatestBooks from "../features/latestBooks/LatestBooks"
// import LatestAdvService from "../features/latestBooks/components/LatestAdvService";
import { Helmet } from 'react-helmet-async';
import { useMetadata } from '../hooks/useMetadata';
import { useTranslation } from 'react-i18next';

export default function Home() {
    const { i18n } = useTranslation();
    useMetadata(i18n.language);

    return (
        <>
            <Helmet>
                <html lang={i18n.language} />
                <link rel="alternate" hrefLang="ar" href="https://masar-t.com.sa/ar" />
                <link rel="alternate" hrefLang="en" href="https://masar-t.com.sa/en" />
            </Helmet>

            <HomeSlider />
            <AllServicesBox />
            <div className="container py-4 mt-4 d-flex flex-column flex-md-row justify-content-between align-items-start">
                <LatestBooks />
                {/* <LatestAdvService /> */}
            </div>
        </>
    );
};